<script lang="ts">
  import type { NodeViewProps } from "@tiptap/core";
  import { NodeViewWrapper, NodeViewContent } from "svelte-tiptap";
  import { tabBlocks } from "app/components/editor/extensions/blocks/Tabs/tabs";

  export let node: NodeViewProps["node"];
  export let getPos: NodeViewProps["getPos"];
  export let editor: NodeViewProps["editor"];
  export let deleteNode: NodeViewProps["deleteNode"];

  $$restProps; // consume unused tiptap props

  let isToBeDeleted = false;

  $: tabId = node.attrs.id;
  $: blockId = node.attrs.blockId;

  $: isActive = $tabBlocks.get(blockId)?.activeTab === tabId;
  $: isToBeDeleted = $tabBlocks.get(blockId)?.tabToDelete === tabId;
  $: if (isToBeDeleted) {
    deleteContent();
  }

  const deleteContent = () => {
    // default deleteNode can sometimes delete the previous tab if there is no content in it
    // (tabs are inserted last - first so the previous tab is below it in the doc)
    // deleting the content of this tab first, then the node, fixes this issue
    const from = getPos();
    const to = from + node.nodeSize;
    editor.commands.deleteRange({ from: from + 1, to: to });
    deleteNode();
  };

  $: direction = $tabBlocks.get(blockId)?.clickDirection;
  $: clickFromLeft = direction === "left";
  $: clickFromRight = direction === "right";
</script>

<NodeViewWrapper data-uuid={tabId}>
  <div
    class="p-4"
    class:hidden={!isActive}
    class:animate-fade-in-left={clickFromLeft}
    class:animate-fade-in-right={clickFromRight}
    role="tabpanel"
  >
    <NodeViewContent />
  </div>
</NodeViewWrapper>
